import { createContext } from 'react';

export const SELECTED_USER_ID_KEY = 'delogue-selected-user-id';

export type SelectedUserContextType = {
  selectedUserId: string | null;
  selectUser: (userId: string) => void;
  clearSelectedUser: () => void;
};

export const SelectedUserContext = createContext<SelectedUserContextType>({
  selectedUserId: null,
  selectUser: () => undefined,
  clearSelectedUser: () => undefined,
});
